import {useState, useEffect} from 'react'
import {StyledBox, StyledChatIconButton, StyledChatIconToolTip, StyledChatWindowParentContainer} from './ChatbotStyles'
import ChatWindow from './ChatWindow'
import {usePermission} from '../../store/hooks/permission'
import PropTypes from 'prop-types'
import {ReactComponent as ChatbotIcon} from '../../icons/chatbot/chatbot_icon.svg'
import {AnalyticsHandler} from '../../shared/handlers/analytics/handlers'

const Chatbot = ({admin}) => {
  const title = `Ready to explore health data with your ✨AI Agent?`
  const rightOffset = 20
  const [showChatWindow, setShowChatWindow] = useState(false)
  const [chatbotTooltipOpen, setChatbotTooltipOpen] = useState(false)

  useEffect(() => {
    const handleOpenChatbot = () => {
      setShowChatWindow(true)
      setChatbotTooltipOpen(false)
      AnalyticsHandler.onChatbotButtonClick({button: {name: 'Open Chatbot From Persona'}})
    }

    globalThis.addEventListener('openChatbot', handleOpenChatbot)

    return () => {
      globalThis.removeEventListener('openChatbot', handleOpenChatbot)
    }
  }, [])

  const handleChatButtonClick = () => {
    setShowChatWindow(!showChatWindow)
    setChatbotTooltipOpen(false)
    AnalyticsHandler.onChatbotButtonClick({button: {name: 'Chatbot'}})
  }

  // getting the healthAndEquityConditions from the context
  const {permission} = usePermission()
  const isChatbotAllowed = permission?.healthEquityConditionList?.chatbotFlagPermissions?.[0] === 1 || admin

  const handleClose = () => {
    setShowChatWindow(false)
  }

  return (
    <>
      {isChatbotAllowed && (
        <StyledBox rightOffset={rightOffset} className='mui-fixed'>
          <StyledChatIconToolTip
            title={title}
            arrow
            open={chatbotTooltipOpen}
            onOpen={() => setChatbotTooltipOpen(true)}
            onClose={() => setChatbotTooltipOpen(false)}
          >
            <StyledChatIconButton onClick={handleChatButtonClick} disabled={showChatWindow}>
              <ChatbotIcon />
            </StyledChatIconButton>
          </StyledChatIconToolTip>
        </StyledBox>
      )}
      <StyledChatWindowParentContainer showChatWindow={showChatWindow}>
        <ChatWindow handleClose={handleClose} showChatWindow={showChatWindow} permission={permission} admin={admin} />
      </StyledChatWindowParentContainer>
    </>
  )
}
Chatbot.propTypes = {
  admin: PropTypes.bool
}
export default Chatbot
